import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import DriveItemList from '../../components/DriveItemList';
import DriveItemUtils from '../../utils/driveItem';
import Utils from '../../utils';

interface DriveItemListOwnProps {
	navigationItems: JSX.Element[];
	folderId?: number;
}

const mapStateToProps = (state: StoreState, ownProps: DriveItemListOwnProps) => {
	const { driveList, search, routerParamsHistory, galleryInfos } = state;
	const { driveItems, isEditMode, isLoading } = driveList;
	const { folderId } = ownProps;
	const privateDirId = Utils.getPrivateDirId(driveList, galleryInfos.config);
	const currentFolderId = Utils.getCurrentFolderId(galleryInfos.config.applicationGallery, routerParamsHistory);
	const isPrivateDir = privateDirId === currentFolderId;

	return {
		displayType: DriveItemUtils.getDisplayType(driveList, routerParamsHistory, folderId),
		storeDriveItems: driveItems,
		showSearchField: search.isShown,
		isPrivateDir,
		sharedDirId: Utils.getSharedDirId(driveList, galleryInfos),
		isEditMode,
		isEditButtonDisplayed: DriveItemUtils.isPrivateDirDescendant(folderId, privateDirId, driveItems),
		isLoading,
	};
};

export default connect(mapStateToProps)(DriveItemList);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/index.tsx